module.exports = __webpack_public_path__ + "static/media/John R. Hartnett@2x.99278d31.jpg";